/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentItemPlaceholder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M20.5 13.6c-1.2-.8-2.8-.8-4 0-1.4 1-1.9 2.9-1.1 4.5.5 1 1.3 2.2 2.4 3.5l.8.9.8-.9c1.1-1.3 1.9-2.5 2.4-3.5.6-1.6.1-3.5-1.3-4.5zm-.7 3.7c-.2.4-.6 1.1-1.3 2.1-.7-1-1.1-1.7-1.3-2.1-.3-.7-.2-1.6.5-2 .3-.2.6-.3.9-.3s.6.1.9.3c.5.4.7 1.3.3 2zM6 6h3v2H6zm5 4h7v2h-7zm-5 0h3v2H6zm5-4h7v2h-7zm-5 8h3v2H6z" />
      <path d="M2 2v20h10v-2H4V4h16v8h2V2z" />
    </g>
  </Icon>
);
export { SvgContentItemPlaceholder as ContentItemPlaceholder };
